import PropTypes from 'prop-types';
import { useState } from 'react';

import { deleteAddress, getAddresses } from '../../api/ans';
import addresArr from '../../assets/images/addresArr.svg';
import wastebasketHover from '../../assets/images/Property 1=hover.svg';
import radioHover from '../../assets/images/Radio.svg';
import radio from '../../assets/images/RadioDef.svg';
import wastebasket from '../../assets/images/waste-basket.svg';
import { setAddresList } from '../../store/slices/ordersSlice';
import { useAppDispatch } from '../../store/store';
import styles from './styles/styles.module.css';

function AdressCard({
  title,
  subtitle,
  addresRef,
  handleClick,
  isSelected,
  isMainCard,
  disabled,
  setAddress,
}) {
  const [hover, setHover] = useState();
  const dispatch = useAppDispatch();

  // Удаление только по корзине; клик не должен всплывать до карточки,
  // иначе удаляемый адрес ещё и выбирается.
  const handleDelete = (e) => {
    e.stopPropagation();
    deleteAddress({
      address_ref: addresRef,
    }).then(() => {
      setAddress(addresRef);
      getAddresses().then((data) => {
        dispatch(setAddresList(data));
      });
    });
  };

  return (
    <div
      className={`${isSelected ? styles.AddStCard : styles.AdressCard}  ${disabled ? styles.disabled : ''}`}
      onClick={() => handleClick()}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      {!isMainCard ? (
        <img src={isSelected ? radioHover : radio} width={24} height={24} />
      ) : null}
      <div className={styles.AddMoon}>
        <div className={styles.AddStorage}>
          <h3 className={styles.AddNextTexst}>{title} </h3>
          <p className={`${styles.AddAnotherTexst} ${disabled ? styles.textDis : ''}`}>
            {subtitle}
          </p>
        </div>
        <div
          onMouseEnter={() => {
            setHover(true);
          }}
          onMouseLeave={() => {
            setHover(false);
          }}
          onClick={isMainCard ? undefined : handleDelete}
          role={isMainCard ? undefined : 'button'}
          tabIndex={isMainCard ? undefined : 0}
          onKeyDown={
            isMainCard
              ? undefined
              : (e) => {
                  if (e.key === 'Enter') handleDelete(e);
                }
          }
        >
          {isMainCard ? (
            <img className={styles.AddClick} src={addresArr} width={24} height={24} />
          ) : (
            <img
              className={styles.AddClick}
              src={hover ? wastebasketHover : wastebasket}
              width={24}
              height={24}
            />
          )}
        </div>
      </div>
    </div>
  );
}

AdressCard.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  addresRef: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  isMainCard: PropTypes.bool,
  disabled: PropTypes.bool,
  setAddress: PropTypes.func,
};

export default AdressCard;
